import React from "react";
import Sidebar from "./Sidebar";
import { Toaster } from "../../components/ui/sonner";

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen flex bg-[#F7FAFC] text-[#0F1E38]">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <div className="max-w-[1600px] mx-auto px-8 py-8">{children}</div>
      </main>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export function PageHeader({ overline, title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between mb-8 pb-6 border-b border-slate-200">
      <div>
        {overline && <div className="overline mb-2">{overline}</div>}
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-[#0F1E38]">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-slate-500 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function VendorTag({ vendor }) {
  const map = {
    Cisco: "vendor-cisco", Fortinet: "vendor-fortinet",
    "Palo Alto": "vendor-palo", F5: "vendor-f5", Checkpoint: "vendor-checkpoint",
  };
  return (
    <span
      data-testid={`vendor-tag-${vendor}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-[10.5px] font-mono uppercase tracking-wider ${map[vendor] || "vendor-default"}`}
    >
      {vendor}
    </span>
  );
}
